import React from 'react';
import styled from 'styled-components';
import { ReactComponent as GridIcon } from 'images/v2/icons/svg/fill/svg/grid_toggle.svg';
import { ReactComponent as ListIcon } from 'images/v2/icons/svg/fill/svg/list_toggle.svg';
import Tooltip from 'components/controls/Tooltip';

export enum DashboardViewMode {
  Cards = 'cards',
  List = 'list',
}

interface Props {
  value: DashboardViewMode;
  onChange: (value: DashboardViewMode) => void;
}

const DashboardViewToggle: React.FC<Props> = ({ value, onChange }) => (
  <Wrapper>
    <ToggleButton
      type="button"
      $active={value === DashboardViewMode.Cards}
      onClick={() => onChange(DashboardViewMode.Cards)}
      aria-label="Card view"
    >
      <GridIcon />
      <Tooltip position="mouse">Card view</Tooltip>
    </ToggleButton>

    <ToggleButton
      type="button"
      $active={value === DashboardViewMode.List}
      onClick={() => onChange(DashboardViewMode.List)}
      aria-label="List view"
    >
      <ListIcon />
      <Tooltip position="mouse">List view</Tooltip>
    </ToggleButton>
  </Wrapper>
);

const Wrapper = styled.div`
  width: 80px;
  height: 40px;
  margin-left: 20px;
  display: flex;
  border-radius: 4px;
  overflow: hidden;
  background-color: ${(props) => props.theme.colors.secondaryLightGreen30};
`;

const ToggleButton = styled.button<{ $active: boolean }>`
  width: 40px;
  height: 40px;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  background-color: ${({ $active, theme }) => ($active ? theme.colors.primaryGreen : 'transparent')};
  color: ${({ $active, theme }) => ($active ? theme.colors.primaryWhite : theme.colors.primaryGreen)};

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background-color: ${({ $active, theme }) => ($active ? theme.colors.primaryGreen : theme.colors.secondaryLightGreen30)};
  }
`;

export default DashboardViewToggle;
